export default "__VITE_ASSET__DDOX$FHa__"